export const JAF_NAVI_TOP = 'https://jafnavi.jp/'

export const JAF_NAVI_TOP_TEST = 'https://test.jafnavi.jp/'

export const JAF_NAVI_DRIVE = 'https://drive.jafnavi.jp/'

export const JAF_NAVI_DRIVE_TEST = 'https://drive-test.jafnavi.jp/drive'

export const JAF_NAVI_DRIVE_ST = 'https://drive-stg.jafnavi.jp/'

export const JAF_NAVI_EVENT = 'https://jafnavi.jp/qs/search_event.php'

export const JAF_NAVI_EVENT_TEST = 'https://test.jafnavi.jp/qs/search_event.php'

export const JAF_NAVI_PRESENT = 'https://jafnavi.jp/qs/search_present.php'

export const JAF_NAVI_PRESENT_TEST =
  'https://test.jafnavi.jp/qs/search_present.php'

export const JAF_NAVI_SHOPPING =
  'https://www.jaf.or.jp/jafnavi/shopping/index.php'

export const JAF_NAVI_SHOPPING_TEST =
  'https://ssl22875.mediagalaxy.ne.jp/jafnavi/shopping/index.php'

export const SSO_LOGIN = 'https://mr.jaf.or.jp/sso/frlogin.php'

export const SSO_LOGIN_TEST = 'https://mr-test.jaf.or.jp/sso/frlogin.php'

export const JAF_NAVI_GUIDE = 'https://area.jaf.or.jp/guidance/index'

export const JAF_NAVI_GUIDE_TEST =
  'https://area.jaf.or.jp/guidance/index'

export const JAF_NAVI_JOIN_GUIDE =
  'https://jaf.or.jp/individual/lp/ad/merit/?utm_source=jafnavi&utm_medium=link&utm_campaign=camp_join'

export const JAF_NAVI_JOIN_GUIDE_TEST =
  'https://staging.jaf.or.jp/individual/lp/ad/merit/?utm_source=jafnavi&utm_medium=link&utm_campaign=camp_join'


export const JAF_NAVI_FAQ = 'https://support.jaf.or.jp/?site_domain=default'

export const JAF_NAVI_FAQ_TEST = 'https://support.jaf.or.jp/?site_domain=default'

export const JAF_NAVI_SITEMAP =
  'https://area.jaf.or.jp/guidance/sitemap'

export const JAF_NAVI_SITEMAP_TEST =
  'https://area.jaf.or.jp/guidance/sitemap'

export const JAF_TOP = 'https://jaf.or.jp/'

export const JAF_TOP_TEST = 'https://staging.jaf.or.jp/'

export const JAF_NAVI_YUTAI_TOP = 'https://yutai.jafnavi.jp/?from_navigation=1'

export const JAF_NAVI_YUTAI_TOP_TEST = 'https://yutai-test.jafnavi.jp/?from_navigation=1'
